<div fxLayout="row" fxLayoutGap="5px">
  <div>
    <form [formGroup]="periodeFormGroup" *ngIf="byDate">

      <mat-form-field>
        <input matInput formControlName="date_debut"
               matTooltip="Export des dar par dates de création."
               (dateChange)="onDateSelected($event, 'debut')"
               [matDatepickerFilter]="dateSvc.filterWE"
               [matDatepicker]="date_debut" placeholder="Du :">
        <mat-datepicker-toggle matSuffix [for]="date_debut"></mat-datepicker-toggle>
        <mat-datepicker #date_debut></mat-datepicker>
        <mat-hint>(*)export par dates de création.</mat-hint>
      </mat-form-field>

      <mat-form-field>
        <input matInput formControlName="date_fin"
               matTooltip="Export des dar par dates de création."
               [min]="minDate"
               (dateChange)="onDateSelected($event)"
               [matDatepickerFilter]="dateSvc.filterWE"
               [matDatepicker]="date_fin" placeholder="Au :">
        <mat-datepicker-toggle matSuffix [for]="date_fin"></mat-datepicker-toggle>
        <mat-datepicker #date_fin></mat-datepicker>
      </mat-form-field>
    </form>
  </div>
  <div>
    <button mat-raised-button
            (click)="generateExcel()"
            [matTooltip]="tooltip"
            style="cursor: pointer;"
            [disabled]="!enableExport()">
      <i class="fa fa-file-excel-o fa-2x" aria-hidden="true"></i>
    </button>
  </div>
</div>
